import React, { createContext, useContext, useEffect, useMemo, useReducer } from 'react';
import { DataManagementContext } from '../../components/viewers/DataManagementViewer';
import { gEnums } from '../../enums/globalEnums';
import { alphaHandlers, alphaInitialState, alphaReducer } from '../reducers/AlphaReducer';
import { DataContext } from './DataContext';
import { ParentContext } from './ParentContext';
import { UiItemContext } from './UiItemContext';

export const AlphaContext = createContext();

const AlphaProvider = (props) => {

  const { dataItems, grouping, handleAlphaChange, handleMouseMove } = props ?? {}
  const count = _.size(dataItems)

  // parentContext
  const parentContext = useContext(ParentContext)
  const { states } = parentContext ?? {}
  const { currentSettings_state, page_state } = states
  const { aps_styles } = _.get(currentSettings_state, 'gvviSettings', {});

  const uiItemContext = useContext(UiItemContext)
  const { item_state } = uiItemContext ?? {}
  const { _groupingOpts } = item_state ?? {}

  // dataContext
  const dataContext = useContext(DataContext)
  const { data_state } = dataContext ?? {}
  const { viewListData } = data_state ?? {}
  const _count_vld = _.size(viewListData)

  let _isDirect = false

  switch (props?.origin) {
    case 'uiSidebar':
    case 'uiItem':
      _isDirect = true
      break;
    default:
    // nothing
  }

  // dataManagementContext
  const dataManagementContext = useContext(DataManagementContext)
  const ignoreStyle = dataManagementContext ? true : false

  const alphabetSnC = aps_styles ? aps_styles[gEnums.projectStyles.alphabet] : {}
  if (ignoreStyle) { alphabetSnC.style = {} }

  const init_state = { alphabetSnC, grouping, handleAlphaChange, handleMouseMove }
  const [alpha_state, alpha_dispatch] = useReducer(alphaReducer, init_state, alphaInitialState)
  const alpha_handlers = useMemo(
    () => alphaHandlers(alpha_dispatch, alpha_state),
    [alpha_dispatch, alpha_state]
  );

  useEffect(() => {
    if (!_isDirect && dataItems) {
      alpha_handlers.handleInit_alpha(null, dataItems, grouping, true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataItems, count]);

  useEffect(() => {
    if (_isDirect && viewListData) {
      alpha_handlers.handleInit_alpha(null, viewListData, _groupingOpts, true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewListData, _count_vld]);

  const providerContext = () => <AlphaContext.Provider value={{ alpha_state, alpha_handlers }}>
    {props.children}
  </AlphaContext.Provider>

  return providerContext()
}

export default AlphaProvider